<script>
  import storeGlobal from "../stores/storeGlobal";

  let observer = null;
  observer = new IntersectionObserver(onIntersect, { rootMargin: '300px' });

  function onIntersect(entries) {
    if (entries[0].isIntersecting) {
      let newValue = $storeGlobal.showItems + 20

      storeGlobal.updateItem('showItems', newValue);
    }
  }

  function lazyLoad(node) {
    observer && observer.observe(node);
    return {
      destroy() {
        observer && observer.unobserve(node);
      }
    }
  }
</script>

<div>
  <slot></slot>
  <div use:lazyLoad></div>
</div>
